/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading,
  Button
 } from '../'

export const InfoDisplay = ({ title, subtitle, actionButtons, edit, rows, columns, onCancelClick,
  onSaveClick, onEditClick, noFixedLayout, noButtons, editDisabled, saveDisabled, titleBold,
  saveButtonLabel, className, style }) => (
  <div className={className} style={style}>
    <div className='slds-grid slds-m-bottom_x-small'>
      <div>
        {title &&
          <div>
            <Heading marginBottom={3}>
              {titleBold
                ? <b>{title}</b>
                : title
              }
            </Heading>
          </div>
        }
        {subtitle &&
          <div style={{ fontSize: 'larger'}}>
            {subtitle}
          </div>
        }
      </div>
      {!noButtons &&
        <div className='slds-col_bump-left'>
          {actionButtons &&
            <span className='slds-m-right_small'>
              {actionButtons}
            </span>
          }
          {edit
            ? <span>
                <Button
                  className="slds-m-right_xx-small"
                  minWidth={80}
                  onClick={onCancelClick}>
                  Cancel
                </Button>
                <Button
                  type='brand'
                  minWidth={80}
                  disabled={saveDisabled}
                  onClick={onSaveClick}>
                  {saveButtonLabel || 'Save'}
                </Button>
              </span>
            : <Button onClick={onEditClick} disabled={editDisabled}>
                Edit
              </Button>
          }
        </div>
      }
    </div>
    <table className={`slds-table slds-table_bordered ${noFixedLayout ? '' : "slds-table_fixed-layout"}`}>
      {columns
        ? <thead>
            {columns}
          </thead>
        : <thead></thead>
      }
      {columns
        ? <tbody>
            {rows}
          </tbody>
        : rows
      }
    </table>
  </div>
)

InfoDisplay.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  edit: PropTypes.bool,
  onEditClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  actionButtons: PropTypes.arrayOf(PropTypes.object), // instanceOf(Button)
  columns: PropTypes.element,
  rows: PropTypes.element,
  noFixedLayout: PropTypes.bool,
  noButtons: PropTypes.bool,
  editDisabled: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  titleBold: PropTypes.bool,
  saveButtonLabel: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

InfoDisplay.defaultProps = {
  titleBold: true,
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/info-display/index.js